module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menuItemHead"
  }, [_c('div', {
    staticClass: "menuItemTitle font-italic"
  }, [(_vm.labelId && _vm.labelId !== '') ? _c('span', [_vm._v(_vm._s(_vm.$t(_vm.labelId)))]) : _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
    staticClass: "menuItemSubBar"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-190f786b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-190f786b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/MobileMenuComponents/MobileMenuSectionHeader.vue
// module id = 2348
// module chunks = 2